import React,{useEffect, useRef, useState, useCallback} from 'react';
import ManagedEquipment from './ManagedEquipment';
import { useDispatch, useSelector } from 'react-redux';
import EquipmentTypeDispatch from '../../../../../../Store/AssetManagement/Equipment/EquipmentDispatch';
import ManagedEquipmentDropDownDispatch from '../../../../../../Store/AssetManagement/ManagedEquipmentDropDown/ManagedEquipmentDropDownDispatch';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction'
import CatalogItemDispatch from 'Store/AssetManagement/CatalogItem/CatalogItemDispatch'

interface IProps{
  setItemDetailComponent?:any,
  mobile:any,
  setShowCatalog:any,
  uniqueRefreshUUid:any
}
const ManagedEquipmentContainer = (props:IProps) => {

  //dispatch
  const dispatch = useDispatch();
  const dispatchEquipmentType = EquipmentTypeDispatch.dispatchGetEquipmentType(dispatch);
  const dispatchGetManagedEquipmentDropDown = ManagedEquipmentDropDownDispatch.dispatchGetManagedEquipmentDropDown(dispatch);
  const dispatchCatalogItem = CatalogItemDispatch.dispatchGetCatalogItem(dispatch);

  const initializeManagedEquipmentValidation = {
    EquipmentTypeError: '',
  }
  const [managedEquipmentValidation, setManagedEquipmentValidation] = useState<any>(initializeManagedEquipmentValidation);

const managedEquipRef = useRef<any>([]);

  const { selectedRequisitionType, equipmentDropdown, managedEquipmentValues, selectedEquipmentType, editRequestDetails, isEditRequestClick }: any = useSelector((state? : any) => ({
    selectedRequisitionType: state.RequisitionReducer.selectedRequisitionType,
    equipmentDropdown: state.Equipment.EquipmentType,
    managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
    selectedEquipmentType: state.RequisitionReducer.selectedEquipmentType,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
  }));

  ///Modified dropDown values as required
  const equipmentDropdownList = equipmentDropdown?.map((item: any) =>
    ({ text: item.text, value: item.value, label: item.text, key: item.value })
  );
  const refreshUuid=props.uniqueRefreshUUid;
  useEffect(() => {
    const assetSubTypeId = selectedRequisitionType?.orderRequestTypeId;
    dispatchEquipmentType(assetSubTypeId);
    if(refreshUuid)
    {
        dispatch(RequisitionAction.setSelectedEquipmentType({label : 'Select Equipment Type', text:null, value: null}));

    }
  }, [refreshUuid]);

const handleEquipmentTypeChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setSelectedEquipmentType(item));
  const error = managedEquipmentValidation;
  if(item.label !== 'Select Equipment Type'){
    dispatch(RequisitionAction.setManagedEquipmentValues([]));
    managedEquipRef.current[1]?.focus()
    dispatchGetManagedEquipmentDropDown(item?.value)
    managedEquipmentValidation.EquipmentTypeError = ""
    setManagedEquipmentValidation(error)
  }else{
    managedEquipmentValidation.EquipmentTypeError = "Please select Equipment Type"
    setManagedEquipmentValidation(error)
  }
}

useEffect(() => {
  fieldFocus()
}, [])

const fieldFocus = () =>{
  managedEquipRef.current[0]?.focus()
}

useEffect(()=>{
  if(editRequestDetails?.orderSubTypeId && isEditRequestClick){
    const selectedEquipment = equipmentDropdown?.find((equipment:any) => equipment?.value === editRequestDetails?.orderSubTypeId)
    handleEquipmentTypeChanges(null, {...selectedEquipment, label: selectedEquipment?.text}, 'equipmentType')
    fieldFocus()
  }
}, [isEditRequestClick, equipmentDropdown, refreshUuid])

// useEffect(()=> {
//   if(isEditRequestClick && selectedEquipmentType){
//     // props.setShowCatalog(true)
//     searchOnClick()
//   }
// }, [selectedEquipmentType, managedEquipmentValues])

  const validation: any = () => {
    let error = JSON.parse(JSON.stringify(managedEquipmentValidation));

    if (selectedEquipmentType?.label === undefined || selectedEquipmentType?.label === "" || selectedEquipmentType?.label === null || selectedEquipmentType?.label === "Select Equipment Type") {
      error.EquipmentTypeError = "Please select Equipment Type";
    } else {
      error.EquipmentTypeError = "";
    }
    setManagedEquipmentValidation(error);
    return error;
  }

    const searchOnClick = () => {
      dispatch(RequisitionAction.setIsCatalogItemExist(true));
      let managedEquipmentValidationError = validation();
    let validToShowCatalogItem = true;
      if (managedEquipmentValidationError?.EquipmentTypeError) {
        validToShowCatalogItem = false;
        return validToShowCatalogItem
        //return validToShowCatalogItem = false;
      }
      if(validToShowCatalogItem){
        props.setShowCatalog(true);

        const bodyToPost = {
          filterDropdownIds: Object.values({
            ...managedEquipmentValues,
            subTypeId: undefined,
          }).filter((managedEquipmentValues : any) => managedEquipmentValues?.value != null)
            .map((x?:any) =>Number(x?.value)),
          subTypeId: parseInt(selectedEquipmentType?.value)
        };
        dispatchCatalogItem(bodyToPost);
      }  
    }

    const resetOnClick = () => {
     dispatch(RequisitionAction.setSelectedEquipmentType({label : 'Select Equipment Type', text:null, value: null}))
    }

  return <ManagedEquipment
  selectedEquipmentType={selectedEquipmentType}
  equipmentDropdownList ={equipmentDropdownList}
  managedEquipmentValues={managedEquipmentValues}
  managedEquipRef={managedEquipRef}
  searchOnClick={searchOnClick}
  managedEquipmentValidation = {managedEquipmentValidation}
  resetOnClick = {resetOnClick}
  handleEquipmentTypeChanges = {handleEquipmentTypeChanges}
  />
};

export default ManagedEquipmentContainer;
